import {
  AuthorizationList,
  CanAccess,
} from "../../../components/template/authorization/Authorization";
import { Button } from "antd";

export const initFilterInput = {
  searchName: "",
  page: 1,
  pageSize: 10,
  transactionStartDate: null,
  transactionEndDate: null,
  sortingField: "",
  sortingOrder: "",
};

export const renderColumns = (handleEdit, handleDetail, handleCancel) => {
  return [
    {
      dataIndex: "tanggal_jemput",
      backend_key: "pick_up_date",
      key: "tanggal_jemput",
      title: "Tanggal & Waktu Jemput",
      sorter: true,
    },
    {
      dataIndex: "nama_nasabah",
      backend_key: "nama_nasabah",
      key: "nama_nasabah",
      title: "Nama Nasabah",
    },
    {
      dataIndex: "no_telp",
      key: "no_telp",
      title: "No. Telepon ",
    },
    {
      dataIndex: "nama_kurir",
      key: "nama_kurir",
      title: "Nama Kurir",
    },
    {
      dataIndex: "no_kurir",
      key: "no_kurir",
      title: "No. Telepon Kurir",
    },
    {
      dataIndex: "barang_jaminan",
      key: "barang_jaminan",
      title: "Barang Jaminan ",
    },
    {
      dataIndex: "lokasi_jemput",
      key: "lokasi_jemput",
      title: "Lokasi Jemput",
    },
    {
      dataIndex: "status",
      key: "status",
      title: "Status",
      render: (text) => (
        <div
          style={{
            textAlign: "left",
            color: "#2C465C",
            fontWeight: "bold",
          }}
        >
          {text}
        </div>
      ),
    },
    {
      dataIndex: "action",
      key: "action",
      title: "Aksi",
      width: "10%",
      render: (_, record) => (
        <div className="d-flex flex-column">
          <div className="mr-2 mb-2">
            <CanAccess
              role={AuthorizationList.update_pick_up_gadai}
              yes={
                <Button
                  variant="primary"
                  className="btn-action btn-detail"
                  onClick={() => {
                    handleEdit(record);
                  }}
                >
                  Ubah Jadwal
                </Button>
              }
            />
          </div>

          <div className="mr-2">
            <Button
              variant="outline-primary"
              className="btn-action btn-default font-weight-semi-bold border-2C465C"
              style={{ width: "115px" }}
              onClick={() => handleDetail(record)}
            >
              Detail
            </Button>
          </div>
        </div>
      ),
    },
  ];
};
